export default class AuthorizationError extends Error {
  constructor(errors) {
    super('Authorization Failed');
    this.errors = errors;
    this.name = this.constructor.name;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/error/AuthorizationError.js